import React from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";

import { Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUniversity,
  faMapMarker,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";

export default () => {
  return (
    <Timeline align="left">
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <FontAwesomeIcon icon={faUniversity} size="2x" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h4" component="h1">
            Freelancer
          </Typography>
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={faMapMarker} /> Tehran, Iran <br />
            <FontAwesomeIcon icon={faCalendar} /> 05/2020 - Present
            <br />
            <p>
              Developing softwares in different languages for multiple customers
              but mainly doing research on Computer Vision, esp. on Generative
              Models and CapsNets
            </p>
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <FontAwesomeIcon icon={faUniversity} size="2x" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h4" component="h1">
            Lead Developer
          </Typography>
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={faMapMarker} /> Niktech, Tehran, Iran <br />
            <FontAwesomeIcon icon={faCalendar} /> 01/2018 - 05/2020
            <br />
            <ul>
              <li>
                <Typography variant="h6">Fullstack Developer</Typography>
              </li>
              <p>
                Designed and Developed a national project for "Iran Ministry of
                Road and Urban Developement" which is currently being used in
                IKA
              </p>
            </ul>
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <FontAwesomeIcon icon={faUniversity} size="2x" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h4" component="h1">
            Mid-Senior AI Developer
          </Typography>
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={faMapMarker} /> LifeWeb, Tehran, Iran <br />
            <FontAwesomeIcon icon={faCalendar} /> 07/2019 - 09/2019
          </Typography>
          <ul>
            <li>
              <Typography variant="h6">
                Arabic Natural Language Processing
              </Typography>
            </li>
            <p>
              Using the crawled data from Twitter, crowd sentiment was achieved
              and used as a Topic Modeler
            </p>
          </ul>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <FontAwesomeIcon icon={faUniversity} size="2x" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h4" component="h1">
            Junior Software Developer
          </Typography>
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={faMapMarker} /> Ghalamchi, Tehran, Iran{" "}
            <br />
            <FontAwesomeIcon icon={faCalendar} /> 06/2017 - 11/2017
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
};
